module.exports = __webpack_public_path__ + "img/img6.ffb54154.png";